import { Trans, useTranslation } from "react-i18next"

const AboutUs = () => {
    const  {t} = useTranslation()
    return (
        <section id="aboutme" className='w-11/12 mx-auto py-8 '>
            
            <h2 className='font-bold  text-orange-600  text-2xl lg:text-4xl py-2 text-center mb-8'
                > {t('abouth3')}
            </h2>
            <p className="font-bold text-3xl text-sky-700">
            {t('aboutp1')}
            </p> <br />
            <p className="text-xl">
            {t('aboutp2')}</p>
            <a href="#contact"><p className="text-xl">
            {t('aboutp3')}</p> </a> 
            <h3 className="text-purple-700 font-bold text-lg my-2">
            {t('aboutp4')}</h3>
            <p>
            {t('aboutp5')}</p>
            <p>
            {t('aboutp6')}</p>
            <h3 className="text-purple-700 font-bold text-lg my-2">
            {t('aboutp7')}</h3>
            <p>
            <Trans i18nKey='aboutp8'>
                You might think of using Google Translate or even the free translation services from Youtube. The truth is most translations are not accurate. <span className="italic">Remember that awful translation in a movie?</span>  You probably spent all movie telling yourself you could've done a better job. 
            </Trans>
            </p>
            <p>
                <Trans i18nKey='aboutp9'>
                On the other hand, you would be investing your precious time in something other than your business goal. <span className="italic">Is it worth it? </span> Leave it to the experts! 
                </Trans>
            </p>
                <h3 className="text-purple-700 font-bold text-lg my-2">{t('aboutp10')}</h3>        
                <p>{t('aboutp11')}</p> 
                <p>{t('aboutp12')}</p>
                <p className="italic my-2">{t('aboutp13')}</p>
        </section>
    )
}

export default AboutUs